@if(!showEmptyState) {
  <figure class="highcharts-figure">
    <div class="{{height}} margin-unset" [id]="chartId"></div>
  </figure>
} @else {
  <app-empty-chart [additionalStyle]="height" [circle]="true"></app-empty-chart>
}
